export default __webpack_public_path__ + "static/media/ic_location_blue.30e2a2ad.svg";